import { defineMessages } from "react-intl";

const messages = defineMessages({
  PPS_EMAIL: {
    id: "orderflow.Package.email.name",
    defaultMessage: "Email Essential",
  },
  PPS_SMALL: {
    id: "orderflow.Package.beginner.name",
    defaultMessage: "Beginner",
  },
  PPS_MEDIUM: {
    id: "orderflow.Package.explorer.name",
    defaultMessage: "Explorer",
  },
  PPS_LARGE: {
    id: "orderflow.Package.enthusiast.name",
    defaultMessage: "Enthusiast",
  },
  PPS_XXLARGE: {
    id: "orderflow.Package.guru.name",
    defaultMessage: "Guru",
  },
  WEBSITE_BUILDER_PREMIUM: {
    id: "orderflow.AddonProduct.wsb.name",
    defaultMessage: "Website Builder Premium",
  },
  WEBSITE_BUILDER_ECOMMERCE: {
    id: "orderflow.AddonProduct.onlineshop.name",
    defaultMessage: "Business + Ecommerce",
  },
  SITELOCK_LITE: {
    id: "orderflow.AddonProduct.sitelock.lite.name",
    defaultMessage: "SiteLock Lite",
  },
  MARKETGOO_START: {
    id: "orderflow.AddonProduct.marketgoo.start.name",
    defaultMessage: "SEO Optimizer",
  },
  UBERALL: {
    id: "orderflow.AddonProduct.uberall.name",
    defaultMessage: "Location Listings",
  },
  WORDPRESS_MANAGED: {
    id: "orderflow.AddonProduct.mwp.name",
    defaultMessage: "Managed WP",
  },
  DNS_ADMIN: {
    id: "orderflow.AddonProduct.dnsadmin.name",
    defaultMessage: "Domain Protection",
  },
  MAIL_STORAGE_UNLIMITED: {
    id: "orderflow.AddonProduct.mailstorageunlimited.name",
    defaultMessage: "Email Unlimited",
  },
  EXCHANGE_ONLINE: {
    id: "orderflow.AddonProduct.exchangeOnline.name",
    defaultMessage: "Exchange Online",
  },
  EXCHANGE_M365_BUSINESS_BASIC: {
    id: "orderflow.AddonProduct.exchangeBasic.name",
    defaultMessage: "Microsoft 365 Business Basic",
  },
  EXCHANGE_M365_BUSINESS_STANDARD: {
    id: "orderflow.AddonProduct.exchangeStandard.name",
    defaultMessage: "Microsoft 365 Business Standard",
  },
  ONEVPS_SMALL: {
    id: "orderflow.Package.vpssmall.name",
    defaultMessage: "Cloud server S",
  },
  ONEVPS_MEDIUM: {
    id: "orderflow.Package.vpsmedium.name",
    defaultMessage: "Cloud server M",
  },
  ONEVPS_LARGE: {
    id: "orderflow.Package.vpslarge.name",
    defaultMessage: "Cloud server L",
  },
  ONEVPS_XLARGE: {
    id: "orderflow.Package.vpsxlarge.name",
    defaultMessage: "Cloud server XL",
  },
  ONEVPS_XXLARGE: {
    id: "orderflow.Package.vpsxxlarge.name",
    defaultMessage: "Cloud server XXL",
  },
  MANAGED_ONEVPS_SMALL: {
    id: "orderflow.Package.managedVpssmall.name",
    defaultMessage: "Managed VPS: Cloud Server S",
  },
  MANAGED_ONEVPS_MEDIUM: {
    id: "orderflow.Package.managedVpsmedium.name",
    defaultMessage: "Managed VPS: Cloud Server M",
  },
  MANAGED_ONEVPS_LARGE: {
    id: "orderflow.Package.managedVpslarge.name",
    defaultMessage: "Managed VPS: Cloud Server L",
  },
  MANAGED_ONEVPS_XLARGE: {
    id: "orderflow.Package.managedVpsxlarge.name",
    defaultMessage: "Managed VPS: Cloud Server XL",
  },
  MANAGED_ONEVPS_XXLARGE: {
    id: "orderflow.Package.managedVpsxxlarge.name",
    defaultMessage: "Managed VPS: Cloud Server XXL",
  },
  ONEVPS_PLESK_ADMIN_LICENSE: {
    id: "orderflow.AddonProduct.pleskAdmin.name",
    defaultMessage: "Plesk Web Admin Edition",
  },
  ONEVPS_PLESK_PRO_LICENSE: {
    id: "orderflow.AddonProduct.pleskPro.name",
    defaultMessage: "Plesk Web Pro Edition",
  },
  ONEVPS_PLESK_HOST_LICENSE: {
    id: "orderflow.AddonProduct.pleskHost.name",
    defaultMessage: "Plesk Web Host Edition",
  },
  ONEVPS_WINDOWS_LICENSE_SMALL: {
    id: "orderflow.AddonProduct.vpsWindowsSmall.name",
    defaultMessage: "Windows License",
  },
  ONEVPS_WINDOWS_LICENSE_MEDIUM: {
    id: "orderflow.AddonProduct.vpsWindowsMedium.name",
    defaultMessage: "Windows License",
  },
  ONEVPS_WINDOWS_LICENSE_LARGE: {
    id: "orderflow.AddonProduct.vpsWindowsLarge.name",
    defaultMessage: "Windows License",
  },
  ONEVPS_WINDOWS_LICENSE_XLARGE: {
    id: "orderflow.AddonProduct.vpsWindowsXLarge.name",
    defaultMessage: "Windows License",
  },
  ONEVPS_WINDOWS_LICENSE_XXLARGE: {
    id: "orderflow.AddonProduct.vpsWindowsXXLarge.name",
    defaultMessage: "Windows License",
  },
  ONEVPS_BASIC_BACKUP: {
    id: "orderflow.AddonProduct.Backups.name",
    defaultMessage: "Backups",
  },
  WSB_MINI: {
    id: "orderflow.upsellCards.websiteBuilder.mini.name",
    defaultMessage: "Website Builder Mini",
  },
  WSB_BUSINESS: {
    id: "orderflow.upsellCards.websiteBuilder.business.name",
    defaultMessage: "Website Builder Business",
  },
  WSB_PRO: {
    id: "orderflow.upsellCards.websiteBuilder.pro.name",
    defaultMessage: "Website Builder Pro",
  },
  WSB_ECOMMERCE: {
    id: "orderflow.upsellCards.websiteBuilder.ecommerce.name",
    defaultMessage: "Website Builder Ecommerce",
  },
});

const getProductName = (productId) => {
  const productName = messages[productId];
  const isDevelopmentEnvironment = process.env.NODE_ENV === "development";

  if (!productName && isDevelopmentEnvironment) {
    console.warn(
      [
        `WARNING: No product name was set for product ID "${productId}"!`,
        "(This warning is only shown in development, not in production)",
      ].join(" "),
    );
  }

  return productName;
};

export default getProductName;
